const BREAKPOINTS = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
} as const satisfies Record<string, Breakpoint>;
const ORDERED_BREAKPOINTS: Breakpoint[] = [
  BREAKPOINTS.XXS,
  BREAKPOINTS.XS,
  BREAKPOINTS.S,
  BREAKPOINTS.M,
  BREAKPOINTS.L,
  BREAKPOINTS.XL,
];
type MQ = {
  breakpoint: Breakpoint;
  mediaquery: string;
};
const MEDIA_QUERIES: MQ[] = [
  {
    breakpoint: BREAKPOINTS.XXS,
    mediaquery: '(min-width: 0)',
  },
  {
    breakpoint: BREAKPOINTS.XS,
    mediaquery: '(min-width: 22.51em)',
  },
  {
    breakpoint: BREAKPOINTS.S,
    mediaquery: '(min-width: 40.01em)',
  },
  {
    breakpoint: BREAKPOINTS.M,
    mediaquery: '(min-width: 50.01em)',
  },
  {
    breakpoint: BREAKPOINTS.L,
    mediaquery: '(min-width: 64.01em)',
  },
  {
    breakpoint: BREAKPOINTS.XL,
    mediaquery: '(min-width: 76.26em)',
  },
];
const DEFAULT_CELL_COLS = {
  [BREAKPOINTS.XXS]: 12,
};
export { BREAKPOINTS, ORDERED_BREAKPOINTS, DEFAULT_CELL_COLS, MEDIA_QUERIES };
const DESKTOP: 'DESKTOP' = 'DESKTOP';
const TABLET: 'TABLET' = 'TABLET';
const MOBILE: 'MOBILE' = 'MOBILE';
export const DEVICES = {
  DESKTOP,
  TABLET,
  MOBILE,
};
export type Device = (typeof DEVICES)[keyof typeof DEVICES];
